import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import IGSmartMenu from "../../../assets/img/SolutionsIcons/AgilysysIGSmartMenu.svg";
import { Header } from "../../../components/Header";

const IGSmartMenuFPage = () => {
    return(
        <div className="page splash IGSmartMenuFPage">
            <div className="page-title"><img src={IGSmartMenu} alt=""/></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A cloud-native contactless menu display on a residents' own
mobile device - phone, tablet, or laptop. Residents simply scan a
QR code to access a venue menu that is linked directly to
the actual items available in the OnDemand system, rather
than a PDF or a website link.{'\n\n'}
                </div>
                <div className="std-text">
                The result is a fully contactless menu display experience
that protects the health of residents and staff alike, while
helping to reduce menu printing and update costs.
                </div>
            </div>
            {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGSmartMenu1.png"} alt="" />
        </div>
    )
}

export default IGSmartMenuFPage;